import PanelInlineContent from "../../lib/panel/panel-inline-content";
import { ToggleGroup, ToggleGroupItem } from "@babackapp/ui/components/toggle-group";
import { AlignVerticalJustifyCenter, AlignVerticalJustifyEnd, AlignVerticalJustifyStart } from "lucide-react";
import { useBlockPanelPropsContext } from "../../lib/panel/panel-container";
import { RowBlockProps } from "./types";
import { useTranslation } from "react-i18next";


export default function PanelRowVerticalAlignment() {
  const { t } = useTranslation("editor-blocks-library");
  const blockProps = useBlockPanelPropsContext<RowBlockProps>();
  const value = blockProps.block.properties?.verticalAlignment || "top";

  const handleUpdate = (verticalAlignment: "top" | "middle" | "bottom") => {
    blockProps.formAPI.updateField(blockProps.formAPI.blockPath, {
      ...blockProps.block,
      properties: {
        ...blockProps.block.properties,
        verticalAlignment,
      },
    });
  };

  return (
    <PanelInlineContent title={t("editorBlocksLibrary.blocks.row.panel.verticalAlignment.title", "Vertical alignment")}>
      <ToggleGroup
        variant="default"
        type="single"
        className="bg-background border shadow"
        value={value}
        onValueChange={(value) => {
          if (
            value &&
            (value === "top" || value === "middle" || value === "bottom")
          ) {
            handleUpdate(value);
          }
        }}
      >
        <ToggleGroupItem value="top" aria-label="Toggle align top">
          <AlignVerticalJustifyStart className="h-4 w-4" />
        </ToggleGroupItem>
        <ToggleGroupItem value="middle" aria-label="Toggle align middle">
          <AlignVerticalJustifyCenter className="h-4 w-4" />
        </ToggleGroupItem>
        <ToggleGroupItem value="bottom" aria-label="Toggle align bottom">
          <AlignVerticalJustifyEnd className="h-4 w-4" />
        </ToggleGroupItem>
      </ToggleGroup>
    </PanelInlineContent>
  );
}
